const PaymentOptions = () => {
  return (
    <div className="banks-logo">
      <p>
        <img src="/assets/images/bank-BAY-logo.png" alt="bay" /> 3 เดือน
      </p>
      <p>
        <img src="/assets/images/bank-BBL-logo.png" alt="bbl" /> 3 เดือน
      </p>
      <p>
        <img src="/assets/images/bank-FirstChoice-logo.png" alt="firstchoice" />{" "}
        3 เดือน
      </p>
      <br />
      <p>
        <img src="/assets/images/bank-KBANK-logo.png" alt="kbank" /> 3 เดือน
      </p>
      <p>
        <img src="/assets/images/bank-KTC-logo.png" alt="ktc" /> 3 เดือน
      </p>
    </div>
  );
};

export default PaymentOptions;
